import "frontend/features/projects/components/ProjectQuickview.css.ts.vanilla.css!=!../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"frontend/features/projects/components/ProjectQuickview.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA7VV2W7bMBB891fwMS5Aw_Id5lOKIliTK2kRimTI9ZEW-fdCtJta8oGkTZ4EaJYzw90dafRYTBPjsx2LXwMhDKVg4UWJ0uL-YSAEWKqcJMYmKaHRMcb2dQVBiS3EOykfi2LZuC0U82GLNOTkjgzXSowfBq-D0R-B4rJA-5SGImom75TQ3m4ad5NpkplK71gm-olnRqpsRHvrYx9bDDtM08zktxhL63dK1GQMZnHGPcu_AFpLIVFqoV1NjDIF0KiE87sIoUM6--9Ozrou5x_t3CXO3s0XX8H53QCDtB4MuerHobcBNPGLEuPRolO8zHCNVNWshAar7yarlfjW03gadjVWn-F7lhckgGl9yrVn9s3Fywmx9tFgfKspwl4kb8n0qqc9l8pCYqlrsiYb7tE47_CShe6e3-ejDcSKXMZuLX09fMN3x6b2Kvh2LI47zxFcKn1slNiEgFFDylYtMmPMa0-uauc5nmHT8Qvd2VSRTJ5AJCMZm2CBUR4mk5SYl1Esy3gWjcQQ-dY35kRxnRXfk3R96OW1T4rpWidnyaH8x-je0MHP1DnhLb-It_pY3E5O1ufL-5450fmxY0iu_G-OyYpgaJP6NRM8qbmeXnM9GS30-hs093_OJQcAAA\"}!../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var actions = '_13steql4';
export var address = '_13steqlg';
export var alert = '_13steqli';
export var body = '_13steql6';
export var content = '_13steql5';
export var empty = '_13steqlh';
export var field = '_13steqla';
export var id = '_13steql2';
export var identity = '_13steql1';
export var label = '_13steqlb';
export var name = '_13steql3';
export var person = '_13steqld';
export var placeholder = '_13steql7';
export var section = '_13steql8';
export var sectionTitle = '_13steql9';
export var supply = '_13steqlf';
export var title = '_13steql0';
export var type = '_13steqle';
export var value = '_13steqlc';